module.exports = __webpack_public_path__ + "static/media/video-slash.e8fef9c9.svg";